
import timeLine from '../components/match/timeLine.vue'
import Divider from 'vux/src/components/divider/index.vue'


export default{
props: {
eventHub: Object
},
components:{
timeLine,
Divider,
},
created(){
this.matchId = this.$route.query.matchId;
this.homeTeamId = this.$route.query.homeTeamId;
this.visitTeamId = this.$route.query.visitTeamId;
},
mounted(){

this.initTab();

},
data(){
return{
content:'赛况',
indexContentHeight:0,
homelineUpList:[],
visitlineUpList:[],
homesubstituteList:[],
visitsubstituteList:[],
homeTeamId:'',
visitTeamId:'',
homeTeamHeader:'this.src="' + require('../assets/img/homeTeamHeader.svg') + '"',

visitTeamHeader:'this.src="' + require('../assets/img/visitTeamHeader.svg') + '"',
totalReq:0,
}
},
methods:{
onerror(){
window.alert('img error');
},
initTab(){
this.$nextTick(() => {
this.indexContentHeight = document.body.clientHeight-230;
}),

this.hagkHttp(this.hagkApi.getLineUpByMatchIdAndTeamId(this.matchId, this.homeTeamId), {})
.then((res) => {
for(var i=0;i<res.length;i++){
res[i].assetId = this.getimgUrl(res[i].assetId, 'homeTeam');
if(res[i].assetId.indexOf('../assets/img/homeTeamHeader.svg') != -1){
res[i].loadImgFail = true;
} else{
res[i].loadImgFail = false;
}
if(res[i].name && res[i].name.length > 4)
res[i].name = res[i].name.substring(0, 4)+"……";
}
this.homelineUpList = res;
console.log(this.homelineUpList)
this.changeScoreHeight();
this.totalReq++;
}, (error) => {
this.totalReq++;
console.log(error);
window.alert('主队首发球员信息获取失败！');
})

this.hagkHttp(this.hagkApi.getLineUpByMatchIdAndTeamId(this.matchId, this.visitTeamId), {})
.then((res) => {
for(var i=0;i<res.length;i++){
res[i].assetId = this.getimgUrl(res[i].assetId, 'visitTeam');
if(res[i].assetId.indexOf('../assets/img/visitTeamHeader.svg') != -1){
res[i].loadImgFail = true;
} else{
res[i].loadImgFail = false;
}
if(res[i].name && res[i].name.length > 4)
res[i].name = res[i].name.substring(0, 4)+"……";
}
this.visitlineUpList = res;
this.changeScoreHeight();
this.totalReq++;
}, (error) => {
this.totalReq++;
console.log(error);
window.alert('客队首发球员信息获取失败！');
})

this.hagkHttp(this.hagkApi.getSubstitutionByMatchIdAndTeamId(this.matchId, this.homeTeamId), {})
.then((res) => {
for(var i=0;i<res.length;i++){
res[i].assetId = this.getimgUrl(res[i].assetId, 'homeTeam');
if(res[i].assetId.indexOf('../assets/img/homeTeamHeader.svg') != -1){
res[i].loadImgFail = true;
} else{
res[i].loadImgFail = false;
}
if(res[i].name && res[i].name.length > 4)
res[i].name = res[i].name.substring(0, 4)+"……";
}
this.homesubstituteList = res;
this.changeScoreHeight();
this.totalReq++;
}, (error) => {
this.totalReq++;
console.log(error);
window.alert('主队替换球员信息获取失败！');
})

this.hagkHttp(this.hagkApi.getSubstitutionByMatchIdAndTeamId(this.matchId, this.visitTeamId), {})
.then((res) => {
for(var i=0;i<res.length;i++){
res[i].assetId = this.getimgUrl(res[i].assetId, 'visitTeam');
if(res[i].assetId.indexOf('../assets/img/visitTeamHeader.svg') != -1){
res[i].loadImgFail = true;
} else{
res[i].loadImgFail = false;
}
console.log(res[i].loadImgFail)
if(res[i].name && res[i].name.length > 4)
res[i].name = res[i].name.substring(0, 4)+"……";
}
this.visitsubstituteList = res;
this.changeScoreHeight();
this.totalReq++;
}, (error) => {
this.totalReq++;
console.log(error);
window.alert('客队替换球员信息获取失败！');
})

},
getimgUrl(assetId, teamType) {
if (assetId && assetId != null) {
return this.hagkApi.getImgAsset(assetId+'.jpg').url;
} else {
if(teamType == 'homeTeam'){
return "../assets/img/homeTeamHeader.svg";
} else if(teamType == 'visitTeam'){
return "../assets/img/visitTeamHeader.svg"
}
}
},
changeScoreHeight(){



this.eventHub.$emit("resetView");
}
}
}



// WEBPACK FOOTER //
// ./src/views/matchScores.vue